// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Library_library_container__jbXIT {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  min-height: 100vh;
  padding: 20px;
  background-color: #f9f9f9;
}

h1 {
  font-size: 2rem;
  color: #bb1616;
  margin-bottom: 20px;
}

.Library_search_input__VMQny {
  width: 100%;
  max-width: 400px;
  padding: 10px;
  font-size: 1rem;
  margin-bottom: 20px;
  border: 1px solid #ddd;
  border-radius: 5px;
}

.Library_book_list__ZvQkg {
  display: flex;
  flex-direction: column;
  gap: 10px;
  width: 100%;
  max-width: 600px;
}

.Library_book_item__lrn6P {
  padding: 15px;
  background-color: #fff;
  border: 1px solid #ddd;
  border-radius: 5px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  cursor: pointer;
  transition: background-color 0.3s, box-shadow 0.3s;
}

.Library_book_item__lrn6P:hover {
  background-color: #f0f0f0;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.2);
}

.Library_book_item__lrn6P h3 {
  margin: 0;
  font-size: 1.2rem;
  color: #333;
}

.Library_book_item__lrn6P p {
  margin: 5px 0 0;
  font-size: 1rem;
  color: #666;
}

.Library_book_item__lrn6P small {
  font-size: 0.9rem;
  color: #aaa;
}

.Library_loading__RYTND {
  font-size: 1.2rem;
  color: #888;
}

.Library_no_books__PM9S\\+ {
  font-size: 1.2rem;
  color: #bb1616;
}

.Library_pagination__ewfEZ {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-top: 20px;
}

.Library_page_button__jPowi {
  padding: 10px 20px;
  font-size: 1rem;
  color: white;
  background-color: #bb1616;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  transition: background-color 0.3s, transform 0.2s;
}

.Library_page_button__jPowi:disabled {
  background-color: #ddd;
  cursor: not-allowed;
}

.Library_page_button__jPowi:hover:not(:disabled) {
  background-color: #a11414;
  transform: translateY(-2px);
}

.Library_page_button__jPowi:active {
  transform: translateY(0);
}

.Library_book_details__dmaNj {
  width: 100%;
  max-width: 800px;
  margin: 20px auto;
  text-align: left;
}

.Library_back_button__leZQx {
  display: inline-block;
  margin-bottom: 20px;
  padding: 12px 20px;
  font-size: 1rem;
  color: white;
  background-color: #007bff;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  transition: background-color 0.3s, transform 0.2s;
  text-decoration: none;
  text-align: center;
}

.Library_back_button__leZQx:hover {
  background-color: #0056b3;
  transform: translateY(-2px);
}

.Library_back_button__leZQx:active {
  transform: translateY(0);
}

.Library_details_card__ZSuGm {
  padding: 20px;
  background-color: #fff;
  border: 1px solid #ddd;
  border-radius: 10px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  max-width: 800px;
  margin: 0 auto;
}

.Library_details_card__ZSuGm h2 {
  font-size: 2rem;
  color: #333;
  margin-bottom: 20px;
}

.Library_details_card__ZSuGm p {
  font-size: 1.1rem;
  margin: 10px 0;
  color: #555;
}

.Library_pdf_link__y8FwB {
  font-weight: bold;
  color: #bb1616;
  text-decoration: none;
}

.Library_pdf_link__y8FwB:hover {
  text-decoration: underline;
}

/* Адаптивность */
@media (max-width: 768px) {
  .Library_details_card__ZSuGm {
    padding: 15px;
    font-size: 0.9rem;
  }

  .Library_details_card__ZSuGm h2 {
    font-size: 1.5rem;
  }

  .Library_back_button__leZQx {
    font-size: 0.9rem;
    padding: 10px 15px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/Library/Library.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,2BAA2B;EAC3B,iBAAiB;EACjB,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,sBAAsB;EACtB,kBAAkB;EAClB,wCAAwC;EACxC,eAAe;EACf,kDAAkD;AACpD;;AAEA;EACE,yBAAyB;EACzB,wCAAwC;AAC1C;;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,eAAe;EACf,eAAe;EACf,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,YAAY;EACZ,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,iDAAiD;AACnD;;AAEA;EACE,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,2BAA2B;AAC7B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,YAAY;EACZ,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,iDAAiD;EACjD,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,2BAA2B;AAC7B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,sBAAsB;EACtB,mBAAmB;EACnB,wCAAwC;EACxC,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA,iBAAiB;AACjB;EACE;IACE,aAAa;IACb,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;IACjB,kBAAkB;EACpB;AACF","sourcesContent":[".library_container {\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  justify-content: flex-start;\r\n  min-height: 100vh;\r\n  padding: 20px;\r\n  background-color: #f9f9f9;\r\n}\r\n\r\nh1 {\r\n  font-size: 2rem;\r\n  color: #bb1616;\r\n  margin-bottom: 20px;\r\n}\r\n\r\n.search_input {\r\n  width: 100%;\r\n  max-width: 400px;\r\n  padding: 10px;\r\n  font-size: 1rem;\r\n  margin-bottom: 20px;\r\n  border: 1px solid #ddd;\r\n  border-radius: 5px;\r\n}\r\n\r\n.book_list {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 10px;\r\n  width: 100%;\r\n  max-width: 600px;\r\n}\r\n\r\n.book_item {\r\n  padding: 15px;\r\n  background-color: #fff;\r\n  border: 1px solid #ddd;\r\n  border-radius: 5px;\r\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\r\n  cursor: pointer;\r\n  transition: background-color 0.3s, box-shadow 0.3s;\r\n}\r\n\r\n.book_item:hover {\r\n  background-color: #f0f0f0;\r\n  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.2);\r\n}\r\n\r\n.book_item h3 {\r\n  margin: 0;\r\n  font-size: 1.2rem;\r\n  color: #333;\r\n}\r\n\r\n.book_item p {\r\n  margin: 5px 0 0;\r\n  font-size: 1rem;\r\n  color: #666;\r\n}\r\n\r\n.book_item small {\r\n  font-size: 0.9rem;\r\n  color: #aaa;\r\n}\r\n\r\n.loading {\r\n  font-size: 1.2rem;\r\n  color: #888;\r\n}\r\n\r\n.no_books {\r\n  font-size: 1.2rem;\r\n  color: #bb1616;\r\n}\r\n\r\n.pagination {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 10px;\r\n  margin-top: 20px;\r\n}\r\n\r\n.page_button {\r\n  padding: 10px 20px;\r\n  font-size: 1rem;\r\n  color: white;\r\n  background-color: #bb1616;\r\n  border: none;\r\n  border-radius: 5px;\r\n  cursor: pointer;\r\n  transition: background-color 0.3s, transform 0.2s;\r\n}\r\n\r\n.page_button:disabled {\r\n  background-color: #ddd;\r\n  cursor: not-allowed;\r\n}\r\n\r\n.page_button:hover:not(:disabled) {\r\n  background-color: #a11414;\r\n  transform: translateY(-2px);\r\n}\r\n\r\n.page_button:active {\r\n  transform: translateY(0);\r\n}\r\n\r\n.book_details {\r\n  width: 100%;\r\n  max-width: 800px;\r\n  margin: 20px auto;\r\n  text-align: left;\r\n}\r\n\r\n.back_button {\r\n  display: inline-block;\r\n  margin-bottom: 20px;\r\n  padding: 12px 20px;\r\n  font-size: 1rem;\r\n  color: white;\r\n  background-color: #007bff;\r\n  border: none;\r\n  border-radius: 5px;\r\n  cursor: pointer;\r\n  transition: background-color 0.3s, transform 0.2s;\r\n  text-decoration: none;\r\n  text-align: center;\r\n}\r\n\r\n.back_button:hover {\r\n  background-color: #0056b3;\r\n  transform: translateY(-2px);\r\n}\r\n\r\n.back_button:active {\r\n  transform: translateY(0);\r\n}\r\n\r\n.details_card {\r\n  padding: 20px;\r\n  background-color: #fff;\r\n  border: 1px solid #ddd;\r\n  border-radius: 10px;\r\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\r\n  max-width: 800px;\r\n  margin: 0 auto;\r\n}\r\n\r\n.details_card h2 {\r\n  font-size: 2rem;\r\n  color: #333;\r\n  margin-bottom: 20px;\r\n}\r\n\r\n.details_card p {\r\n  font-size: 1.1rem;\r\n  margin: 10px 0;\r\n  color: #555;\r\n}\r\n\r\n.pdf_link {\r\n  font-weight: bold;\r\n  color: #bb1616;\r\n  text-decoration: none;\r\n}\r\n\r\n.pdf_link:hover {\r\n  text-decoration: underline;\r\n}\r\n\r\n/* Адаптивность */\r\n@media (max-width: 768px) {\r\n  .details_card {\r\n    padding: 15px;\r\n    font-size: 0.9rem;\r\n  }\r\n\r\n  .details_card h2 {\r\n    font-size: 1.5rem;\r\n  }\r\n\r\n  .back_button {\r\n    font-size: 0.9rem;\r\n    padding: 10px 15px;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"library_container": `Library_library_container__jbXIT`,
	"search_input": `Library_search_input__VMQny`,
	"book_list": `Library_book_list__ZvQkg`,
	"book_item": `Library_book_item__lrn6P`,
	"loading": `Library_loading__RYTND`,
	"no_books": `Library_no_books__PM9S+`,
	"pagination": `Library_pagination__ewfEZ`,
	"page_button": `Library_page_button__jPowi`,
	"book_details": `Library_book_details__dmaNj`,
	"back_button": `Library_back_button__leZQx`,
	"details_card": `Library_details_card__ZSuGm`,
	"pdf_link": `Library_pdf_link__y8FwB`
};
export default ___CSS_LOADER_EXPORT___;
